import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import { AppConfigContext } from '@providers/AppConfigProvider';

export default function TopComment(): React.JSX.Element {
  const { isMobile } = useContext(AppConfigContext);
  return (
    <Box className="mb-8 max-md:mb-6 relative">
      {isMobile ? (
        <Box className="relative flex items-center">
          <Box className="absolute z-10">
            <h1 className="ml-5 text-2xl font-bold text-left">マンションカルテ</h1>
            <Box className="mt-3 pl-5 py-3 pr-3 max-w-[244px] text-xs bg-white bg-opacity-80 rounded-lg">
              マンションカルテはリノベ不動産が運営する全国マンション情報サイトです。
            </Box>
          </Box>
          <img
            src="assets/images/common/top_main_sp.jpg"
            alt="top_main"
            className="ml-auto	w-2/3"
            width="11"
            height="8"
          />
        </Box>
      ) : (
        <Box className="relative flex justify-end">
          <Box className="absolute left-0 flex flex-col top-1/4  ml-24 mr-10">
            <h1 className="text-2xl font-bold">マンションカルテ</h1>
            <Box className="max-w-[374px] bg-white bg-opacity-80 rounded-lg mt-3 py-4 pr-4">
              <p className="text-sm leading-relaxed">
                マンションカルテはリノベ不動産が運営する情報提供サイトです。15万棟超の全国のマンション情報を掲載。国内最大級のリノベーションサイトリノベ不動産で理想の暮らしがきっと見つかる！
              </p>
            </Box>
          </Box>
          <img src="assets/images/common/top_main.jpg" alt="top_main" className="w-2/3" width="11" height="4" />
        </Box>
      )}
    </Box>
  );
}
